import React, { useState, useContext, useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { InputSwitch } from "primereact/inputswitch";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import { useMediaQuery } from "react-responsive";
import { baseURL, api } from "../../utils/api";

const AddUser = ({ onAddSuccess }) => {
  const toast = useRef(null);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const { user, token } = useContext(AuthContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState(null);
  const [Name, setName] = useState("");
  const [Forname, setForname] = useState("");
  const [egz, setEgz] = useState(null);
  const [users, setUsers] = useState([]);
  const [oddzialy, setOddzialy] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const roleOptions = [
    { label: "Administrator", value: "Administrator" },
    { label: "Użytkownik", value: "User" },
  ];

  // --- Permissions system ---
  const ALL_PERMISSIONS = [
    { section: "Dokumenty" },
    { key: "docs_list", label: "Lista dokumentów", icon: "pi pi-home" },
    { key: "docs_create", label: "Dodaj nowy dokument", icon: "pi pi-plus" },
    { key: "docs_stats", label: "Statystyki dokumentów", icon: "pi pi-chart-bar" },
    { section: "Pojazdy" },
    { key: "vehicles_dashboard", label: "Dashboard", icon: "pi pi-th-large" },
    { key: "vehicles_list", label: "Lista pojazdów", icon: "pi pi-list" },
    { key: "vehicles_services", label: "Serwisy", icon: "pi pi-shield" },
    { key: "vehicles_repairs", label: "Naprawy", icon: "pi pi-wrench" },
    { key: "vehicles_faults", label: "Zgłoś usterkę", icon: "pi pi-exclamation-triangle" },
    { key: "vehicles_workshop", label: "Panel warsztatu", icon: "pi pi-wrench" },
    { key: "vehicles_statistics", label: "Statystyki", icon: "pi pi-chart-bar" },
    { key: "vehicles_settings", label: "Ustawienia floty", icon: "pi pi-cog" },
    { section: "Administracja" },
    { key: "admin_panel", label: "Panel admina", icon: "pi pi-lock" },
  ];

  const [permDialogVisible, setPermDialogVisible] = useState(false);
  const [permUser, setPermUser] = useState(null);
  const [permValues, setPermValues] = useState({});
  const [permSaving, setPermSaving] = useState(false);

  // Password reset state
  const [resetDialogVisible, setResetDialogVisible] = useState(false);
  const [resetUser, setResetUser] = useState(null);
  const [newPassword, setNewPassword] = useState("");
  const [resetSaving, setResetSaving] = useState(false);

  // Notification preferences state
  const NOTIFICATION_TYPES = [
    { key: "service_oc", label: "OC" },
    { key: "service_ac", label: "AC" },
    { key: "service_tech", label: "Badania techniczne" },
    { key: "service_other", label: "Inne serwisy" },
    { key: "fault_reported", label: "Zgłoszone usterki" },
    { key: "repair_completed", label: "Zakończone naprawy" },
  ];
  const [notifDialogVisible, setNotifDialogVisible] = useState(false);
  const [notifUser, setNotifUser] = useState(null);
  const [notifValues, setNotifValues] = useState({});
  const [notifSaving, setNotifSaving] = useState(false);

  const openResetPassword = (u) => {
    setResetUser(u);
    setNewPassword("");
    setResetDialogVisible(true);
  };

  const openNotifPreferences = async (u) => {
    setNotifUser(u);
    setNotifSaving(false);
    // Domyślnie wszystko wyłączone
    const defaults = {};
    NOTIFICATION_TYPES.forEach(nt => { defaults[nt.key] = false; });
    try {
      const res = await api.get("/notification-preferences");
      const userData = res.data.find(ud => ud.id === u.id);
      if (userData && userData.preferences) {
        Object.keys(userData.preferences).forEach(k => { defaults[k] = userData.preferences[k]; });
      }
    } catch (err) { console.error(err); }
    setNotifValues(defaults);
    setNotifDialogVisible(true);
  };

  const saveNotifPreferences = async () => {
    if (!notifUser) return;
    setNotifSaving(true);
    try {
      await api.put(`/notification-preferences/${notifUser.id}`, { preferences: notifValues });
      setNotifDialogVisible(false);
      toast.current.show({ severity: "success", summary: "Sukces", detail: "Preferencje powiadomień zapisane", life: 3000 });
    } catch (err) {
      console.error(err);
      toast.current.show({ severity: "error", summary: "Błąd", detail: "Nie udało się zapisać", life: 3000 });
    }
    setNotifSaving(false);
  };

  const handleResetPassword = async () => {
    if (!resetUser || !newPassword || newPassword.length < 4) {
      toast.current.show({ severity: "warn", summary: "Uwaga", detail: "Hasło musi mieć co najmniej 4 znaki", life: 3000 });
      return;
    }
    setResetSaving(true);
    try {
      await axios.put(`${baseURL}api/users/${resetUser.id}/reset-password`, { newPassword }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setResetDialogVisible(false);
      toast.current.show({ severity: "success", summary: "Sukces", detail: "Hasło zostało zresetowane", life: 3000 });
    } catch (err) {
      console.error(err);
      toast.current.show({ severity: "error", summary: "Błąd", detail: "Nie udało się zresetować hasła", life: 3000 });
    }
    setResetSaving(false);
  };

  const openPermissions = (u) => {
    setPermUser(u);
    // Domyślnie Administrator ma wszystko, User ma podstawowe
    const defaults = {};
    ALL_PERMISSIONS.filter(p => p.key).forEach(p => {
      if (u.role === "Administrator") {
        defaults[p.key] = true;
      } else {
        defaults[p.key] = p.key !== "admin_panel";
      }
    });
    // Nadpisz zapisanymi wartościami
    const saved = u.permissions || {};
    Object.keys(saved).forEach(k => { defaults[k] = saved[k]; });
    setPermValues(defaults);
    setPermDialogVisible(true);
  };

  const savePermissions = async () => {
    if (!permUser) return;
    setPermSaving(true);
    try {
      await axios.put(`${baseURL}api/users/${permUser.id}/permissions`, { permissions: permValues }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // Zaktualizuj lokalnie
      setUsers(users.map(u => u.id === permUser.id ? { ...u, permissions: { ...permValues } } : u));
      setPermDialogVisible(false);
      toast.current.show({ severity: "success", summary: "Sukces", detail: "Uprawnienia zapisane", life: 3000 });
    } catch (err) {
      console.error(err);
      toast.current.show({ severity: "error", summary: "Błąd", detail: "Nie udało się zapisać uprawnień", life: 3000 });
    }
    setPermSaving(false);
  };

  const toggleAllPermissions = (val) => {
    const newPerms = { ...permValues };
    ALL_PERMISSIONS.filter(p => p.key).forEach(p => { newPerms[p.key] = val; });
    setPermValues(newPerms);
  };

  const handleSubmit = () => {
    const newUser = {
      username,
      password,
      role,
      Name,
      Forname,
      kopalnia: role === "Administrator" ? null : egz?.id,
    };
    axios
      .post(`${baseURL}api/usersAdd`, newUser, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        console.log("Dodano użytkownika:", response.data);
        // Czyszczenie formularza
        setUsername("");
        setPassword("");
        setRole(null);
        setName("");
        setForname("");
        setEgz(null);
        setUsers([...users, response.data]);
        if (onAddSuccess) onAddSuccess(); // callback odświeżający listę użytkowników, jeśli istnieje
      })
      .catch((error) => {
        console.error(
          "Błąd dodawania użytkownika:",
          error.response.data.message
        );
        alert("Błąd: " + error.response.data.message);
      });
  };

  useEffect(() => {
    axios
      .get(`${baseURL}api/egz`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => setOddzialy(response.data))
      .catch((error) => console.error("Błąd pobierania opcji egz:", error));

    axios
      .get(`${baseURL}api/users`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => setUsers(response.data))
      .catch((error) => console.error("Błąd pobierania opcji users:", error));
  }, [token]);

  const handleDelete = (user) => {
    axios
      .delete(`${baseURL}api/users/${user.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        console.log("Usunięto oddział:", response.data);
        setUsers(users.filter((o) => o.id !== user.id));
      })
      .catch((error) => {
        console.error("Błąd usuwania oddziału:", error);
      });
  };

  const handleEditClick = (user) => {
    setEditingUser({ ...user });
  };

  const handleSaveClick = () => {
    console.log("Zapisywanie zmian:", editingUser);
    axios
      .put(`${baseURL}api/users/${editingUser.id}`, editingUser, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setUsers(
          users.map((u) => (u.id === editingUser.id ? response.data : u))
        );
        setEditingUser(null);
        toast.current.show({
          severity: "success",
          summary: "Sukces",
          detail: "Użytkownik zaktualizowany",
          life: 3000,
        });
      })
      .catch((error) => console.error("Błąd aktualizacji użytkownika:", error));
  };

  const handleCancelClick = () => {
    setEditingUser(null);
    toast.current.show({
      severity: "info",
      summary: "Anulowano",
      detail: "Anulowano edycję użytkownika",
      life: 3000,
    });
  };

  const textBodyTemplate = (rowData, field) => {
    if (editingUser && editingUser.id === rowData.id) {
      return (
        <InputText
          value={editingUser[field]}
          style={{ width: "100%", maxWidth: "10rem" }}
          onChange={(e) =>
            setEditingUser({ ...editingUser, [field]: e.target.value })
          }
        />
      );
    }
    return rowData[field];
  };

  const roleBodyTemplate = (rowData) => {
    if (editingUser && editingUser.id === rowData.id) {
      return (
        <Dropdown
          value={editingUser.role}
          options={roleOptions}
          onChange={(e) => setEditingUser({ ...editingUser, role: e.value })}
        />
      );
    }
    return rowData.role;
  };

  const egzBodyTemplate = (rowData) => {
    if (editingUser && editingUser.id === rowData.id) {
      return editingUser.role === "User" ? (
        <Dropdown
          value={editingUser.kopalnia}
          options={oddzialy}
          optionLabel="adres"
          style={{ width: "100%" }}
          onChange={(e) =>
            setEditingUser({ ...editingUser, kopalnia: e.value.id })
          }
        />
      ) : (
        ""
      );
    }
    return oddzialy.find((egz) => egz.id === rowData.kopalnia)?.adres || "";
  };

  const actionBodyTemplate = (rowData) => {
    if (editingUser && editingUser.id === rowData.id) {
      return (
        <React.Fragment>
          <Button
            icon="pi pi-save"
            className="p-button-success p-mr-2"
            onClick={handleSaveClick}
          />
          <Button
            icon="pi pi-times"
            className="p-button-secondary"
            onClick={handleCancelClick}
          />
        </React.Fragment>
      );
    } else {
      return (
        <div style={{ display: "flex", gap: "0.25rem" }}>
          <Button
            onClick={() => handleEditClick(rowData)}
            icon="pi pi-pencil"
            className="p-button-text p-button-sm"
            tooltip="Edytuj"
            tooltipOptions={{ position: "top" }}
          />
          <Button
            onClick={() => openPermissions(rowData)}
            icon="pi pi-shield"
            className="p-button-text p-button-sm p-button-info"
            tooltip="Uprawnienia"
            tooltipOptions={{ position: "top" }}
          />
          <Button
            onClick={() => openResetPassword(rowData)}
            icon="pi pi-key"
            className="p-button-text p-button-sm p-button-warning"
            tooltip="Resetuj hasło"
            tooltipOptions={{ position: "top" }}
          />
          <Button
            onClick={() => openNotifPreferences(rowData)}
            icon="pi pi-bell"
            className="p-button-text p-button-sm p-button-help"
            tooltip="Powiadomienia"
            tooltipOptions={{ position: "top" }}
          />
        </div>
      );
    }
  };

  const handleToggleAvailability = (user) => {
    if (editingUser) {
      setEditingUser({ ...editingUser, dostepny: !editingUser.dostepny });
    }
  };

  const availabilityBodyTemplate = (rowData) => {
    if (editingUser && editingUser.id === rowData.id) {
      return (
        <Checkbox
          checked={editingUser.dostepny}
          onChange={() => handleToggleAvailability(rowData)}
        />
      );
    } else {
      return <Checkbox checked={rowData.dostepny} disabled />;
    }
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="add-form">
        <h2>Dodaj nowego użytkownika</h2>
        <div className="add-input">
          <label>Login:</label>
          <InputText
            className="add-inputText"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>
        <div className="add-input">
          <label>Hasło:</label>
          <Password
            style={{ width: "100%" }}
            inputStyle={{ width: "100%" }}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            feedback={false}
            toggleMask
          />
        </div>
        <div className="add-input">
          <label>Rola:</label>
          <Dropdown
            value={role}
            options={roleOptions}
            onChange={(e) => setRole(e.value)}
            placeholder="Wybierz rolę"
            className="wz-dropdown1"
          />
        </div>
        <div className="add-input">
          <label>Imię:</label>
          <InputText
            className="add-inputText"
            value={Forname}
            onChange={(e) => setForname(e.target.value)}
          />
        </div>
        <div className="add-input">
          <label>Nazwisko:</label>
          <InputText
            className="add-inputText"
            value={Name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        {role === "User" && (
          <div className="add-input">
            <label>Kopalnia</label>
            <Dropdown
              value={egz}
              options={oddzialy}
              optionLabel="adres"
              onChange={(e) => setEgz(e.value)}
              placeholder="Wybierz oddział"
              className="wz-dropdown1"
            />
          </div>
        )}
        <Button
          label="Dodaj użytkownika"
          onClick={handleSubmit}
          className="p-button"
          disabled={
            !username ||
            !password ||
            !role ||
            !Name ||
            !Forname ||
            (role === "User" && !egz)
          }
        />
      </div>

      <Button
        label={showAll ? "Pokaż tylko dostępnych" : "Pokaż wszystkie"}
        onClick={() => setShowAll(!showAll)}
        style={{ margin: "1rem 0" }}
      />
      {isMobile && (
        <div style={{ textAlign: "center", marginTop: "1rem" }}>
          <i>
            W celu uzyskania lepszej widoczności danych, skorzystaj z orientacji
            poziomej
          </i>
        </div>
      )}
      <DataTable
        value={showAll ? users : users.filter((u) => u.dostepny)}
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 15]}
        selectionMode="single"
        style={{ marginTop: "30px" }}
      >
        <Column
          field="username"
          header="Login"
          sortable
          body={(rowData) => textBodyTemplate(rowData, "username")}
        />
        <Column field="role" header="Rola" sortable body={roleBodyTemplate} />
        <Column
          field="forname"
          header="Imię"
          sortable
          body={(rowData) => textBodyTemplate(rowData, "forname")}
        />
        <Column
          field="name"
          header="Nazwisko"
          sortable
          body={(rowData) => textBodyTemplate(rowData, "name")}
        />
        <Column
          header="Kopalnia"
          field="kopalnia"
          sortable
          body={egzBodyTemplate}
          style={{ minWidth: "10em" }}
        />
        <Column header="Dostępny" field="dostepny" sortable body={availabilityBodyTemplate} />
        {user?.role === "Administrator" && (
          <Column header="Akcje" body={actionBodyTemplate} />
        )}
      </DataTable>

      {/* Permissions Dialog */}
      <Dialog
        header={permUser ? `Uprawnienia: ${permUser.forname} ${permUser.name} (${permUser.username})` : "Uprawnienia"}
        visible={permDialogVisible}
        style={{ width: "540px", maxWidth: "95vw" }}
        onHide={() => setPermDialogVisible(false)}
        footer={
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
            <Button label="Anuluj" icon="pi pi-times" className="p-button-text" onClick={() => setPermDialogVisible(false)} />
            <Button label={permSaving ? "Zapisywanie..." : "Zapisz"} icon="pi pi-check" onClick={savePermissions} disabled={permSaving} />
          </div>
        }
      >
        {permUser && (
          <div>
            <div style={{ marginBottom: "1rem", display: "flex", gap: "0.5rem", justifyContent: "flex-end" }}>
              <Button label="Zaznacz wszystko" size="small" className="p-button-text p-button-sm" onClick={() => toggleAllPermissions(true)} />
              <Button label="Odznacz wszystko" size="small" className="p-button-text p-button-sm p-button-secondary" onClick={() => toggleAllPermissions(false)} />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "0" }}>
              {ALL_PERMISSIONS.map((item, idx) => {
                if (item.section) {
                  return (
                    <div key={`s-${idx}`} style={{
                      padding: "0.5rem 0.75rem",
                      background: "#eff6ff",
                      fontWeight: 700,
                      fontSize: "0.8rem",
                      color: "#2563eb",
                      borderBottom: "1px solid #e2e8f0",
                      marginTop: idx > 0 ? "0.25rem" : 0
                    }}>
                      {item.section}
                    </div>
                  );
                }
                return (
                  <div key={item.key} style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "0.55rem 0.75rem",
                    borderBottom: "1px solid #f1f5f9",
                  }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", fontSize: "0.88rem" }}>
                      <i className={item.icon} style={{ fontSize: "0.85rem", color: "#94a3b8" }} />
                      <span>{item.label}</span>
                    </div>
                    <InputSwitch
                      checked={!!permValues[item.key]}
                      onChange={(e) => setPermValues({ ...permValues, [item.key]: e.value })}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </Dialog>

      {/* Password Reset Dialog */}
      <Dialog
        header={resetUser ? `Resetuj hasło: ${resetUser.forname} ${resetUser.name} (${resetUser.username})` : "Resetuj hasło"}
        visible={resetDialogVisible}
        style={{ width: "420px", maxWidth: "95vw" }}
        onHide={() => setResetDialogVisible(false)}
        footer={
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
            <Button label="Anuluj" icon="pi pi-times" className="p-button-text" onClick={() => setResetDialogVisible(false)} />
            <Button label={resetSaving ? "Zapisywanie..." : "Resetuj hasło"} icon="pi pi-key" className="p-button-warning" onClick={handleResetPassword} disabled={resetSaving || !newPassword || newPassword.length < 4} />
          </div>
        }
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          <p style={{ margin: 0, color: "#64748b" }}>Podaj nowe hasło dla użytkownika.</p>
          <div>
            <label style={{ display: "block", marginBottom: "0.5rem", fontWeight: 600 }}>Nowe hasło</label>
            <Password
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              feedback={false}
              toggleMask
              style={{ width: "100%" }}
              inputStyle={{ width: "100%" }}
            />
          </div>
          {newPassword && newPassword.length < 4 && (
            <small style={{ color: "#ef4444" }}>Hasło musi mieć co najmniej 4 znaki</small>
          )}
        </div>
      </Dialog>

      {/* Notification Preferences Dialog */}
      <Dialog
        header={notifUser ? `Powiadomienia: ${notifUser.forname} ${notifUser.name} (${notifUser.username})` : "Powiadomienia"}
        visible={notifDialogVisible}
        style={{ width: "480px", maxWidth: "95vw" }}
        onHide={() => setNotifDialogVisible(false)}
        footer={
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>
            <Button label="Anuluj" icon="pi pi-times" className="p-button-text" onClick={() => setNotifDialogVisible(false)} />
            <Button label={notifSaving ? "Zapisywanie..." : "Zapisz"} icon="pi pi-check" onClick={saveNotifPreferences} disabled={notifSaving} />
          </div>
        }
      >
        {notifUser && (
          <div>
            <p style={{ margin: "0 0 1rem 0", color: "#64748b", fontSize: "0.9rem" }}>
              Określ, o czym ten użytkownik będzie otrzymywał powiadomienia push.
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: "0" }}>
              {NOTIFICATION_TYPES.map(nt => (
                <div key={nt.key} style={{
                  display: "flex", alignItems: "center", justifyContent: "space-between",
                  padding: "0.55rem 0.75rem", borderBottom: "1px solid #f1f5f9"
                }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", fontSize: "0.88rem" }}>
                    <i className="pi pi-bell" style={{ fontSize: "0.85rem", color: "#94a3b8" }} />
                    <span>{nt.label}</span>
                  </div>
                  <InputSwitch
                    checked={!!notifValues[nt.key]}
                    onChange={(e) => setNotifValues({ ...notifValues, [nt.key]: e.value })}
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </Dialog>
    </>
  );
};

export default AddUser;
